import { Order, RepositoryError } from "@invoiceddd/domain";
import { Context, Effect, Option } from "effect";

/**
 * Repository interface for Order operations.
 * This port defines the contract for order persistence operations.
 *
 * @interface OrderRepository
 * @since 0.1.0
 * @see {@link RepositoryError}
 * @see {@link Order}
 * @example
 * import { OrderRepository } from '@invoiceddd/application';
 * // Inject implementation at runtime
 */
export interface OrderRepositorySchema {
  /**
   * Find an order by ID.
   * @param orderId The order ID to search for
   * @returns Effect that resolves to Option containing the order if found
   * @since 0.1.0
   * @example
   * const result = await orderRepository.findById('order-123')
   */
  // eslint-disable-next-line no-unused-vars
  readonly findById: (_orderId: string) => Effect.Effect<Option.Option<Order>, RepositoryError>;
}

/**
 * Context tag for OrderRepository service.
 * Used for dependency injection.
 * @since 0.1.0
 * @see {@link OrderRepository}
 */
export class OrderRepository extends Context.Tag("@/applayer/ports/OrderRepository")<
  OrderRepository,
  OrderRepositorySchema
>() {}
